import axios from "../../../common/config/axios";
import * as types from "./types";

export const getDailyCheckInHistory = (data) => (dispatch) => {
  axios
    .get("daily_check_in/history", { params: data })
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_LIST_HISTORY,
        payload: res,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const exportDailyCheckInHistory = (data) => (dispatch) => {
  axios
    .get("daily_check_in/export", { 
      params: data,
      responseType: 'blob'
    })
    .then((res) => {
      // Create filename with start and end dates
      const formatDateForFilename = (dateString) => {
        if (!dateString) return '';
        // Convert from YYYY/MM/DD HH:mm:ss to YYYY-MM-DD_HH-mm-ss
        return dateString.replace(/\//g, '-').replace(/ /g, '_').replace(/:/g, '-');
      };
      
      const startDate = formatDateForFilename(data.startDate);
      const endDate = formatDateForFilename(data.endDate);
      
      const filename = `daily_check_in_history_${startDate}_to_${endDate}.csv`;
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      console.error(err);
    });
};

export const getDailyCheckInRuleSetting = (data) => (dispatch) => {
  axios
    .get("daily_check_in/rule_setting", { params: data })
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_LIST_RULE_SETTING,
        payload: res,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const updateDailyCheckInRuleSetting = (data) => (dispatch) => {
  axios
    .post("daily_check_in/rule_setting", data)
    .then((res) => {
      dispatch({
        type: types.DAILY_CHECK_IN_UPDATE_RULE_SETTING,
        payload: res,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};
